import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "问董秘", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_LeftTree = _resolveComponent("LeftTree")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_Content = _resolveComponent("Content")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_Top10 = _resolveComponent("Top10")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_optionalshares = _resolveComponent("optionalshares")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    class: _normalizeClass(["asktheSecretary", _ctx.theme])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_Search, {
            ref: "topsearch",
            onChangeObj: _ctx.changeObj,
            theme: _ctx.theme,
            navObj: _ctx.navObj,
            onClearsearch: _ctx.clearsearch
          }, null, 8, ["onChangeObj", "theme", "navObj", "onClearsearch"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_sider, null, {
            default: _withCtx(() => [
              _createVNode(_component_LeftTree, {
                token: _ctx.token,
                theme: _ctx.theme,
                keywords: _ctx.storeObj,
                AQContent: _ctx.AQContent,
                onClickNav: _ctx.clickNav,
                onInitInfoSecretaryTop: _ctx.initInfoSecretaryTop
              }, null, 8, ["token", "theme", "keywords", "AQContent", "onClickNav", "onInitInfoSecretaryTop"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_Content, {
                ref: "content",
                token: _ctx.token,
                theme: _ctx.theme,
                navObj: _ctx.navObj,
                sectorExtObj: _ctx.sectorExtObj,
                searchObj: _ctx.searchObj,
                keywords: _ctx.storeObj,
                onAQContent: _ctx.getAQContent
              }, null, 8, ["token", "theme", "navObj", "sectorExtObj", "searchObj", "keywords", "onAQContent"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_sider, { width: "500" }, {
            default: _withCtx(() => [
              _createVNode(_component_Top10, {
                token: _ctx.token,
                theme: _ctx.theme,
                navObj: _ctx.navObj,
                searchObj: _ctx.searchObj,
                initInfoSecretaryTop: _ctx.initInfoSecretaryTopData,
                onClickHotKeywords: _ctx.clickHotKeywords
              }, null, 8, ["token", "theme", "navObj", "searchObj", "initInfoSecretaryTop", "onClickHotKeywords"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_optionalshares)
    ]),
    _: 1
  }, 8, ["class"]))
}